import { forwardRef } from 'react';

import * as DialogPrimitive from '@radix-ui/react-dialog';
import { twMerge } from 'tailwind-merge';

const ModalOverlay = forwardRef<HTMLDivElement, DialogPrimitive.DialogOverlayProps>(function DialogOverlay({ className, ...props }, ref) {
  return (
    <DialogPrimitive.DialogOverlay
      ref={ref}
      {...props}
      className={twMerge('fixed inset-0 z-50 bg-black/40 transition-opacity', className)}
    />
  );
});

export { ModalOverlay };
